import { RealtimeModes as modes } from "mobility-toolbox-js/api";
import GeoJSON from "ol/format/GeoJSON";
import { unByKey } from "ol/Observable";
import { memo, useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";

import { SEV_SOURCE_ID } from "../constants";

const format = new GeoJSON();
const formatToLonLat = new GeoJSON({
  dataProjection: "EPSG:3857",
  featureProjection: "EPSG:4326",
});

function SevLayer() {
  const busTrajectories = useSelector((state) => state.busTrajectories);
  const backgroundLayer = useSelector((state) => state.backgroundLayer);
  const mode = useSelector((state) => state.mode);
  const [sevSource, setSevSource] = useState();
  const [retry, setRetry] = useState(0);

  // Since last maplibre-gl version (> 10.12) the loading of style has probably changed
  // so we have to check manually, to make sure the source data are added with a
  // good timing.
  useEffect(() => {
    if (!backgroundLayer || mode !== modes.SCHEMATIC) {
      return;
    }
    const mbMap = backgroundLayer.mbMap;
    const style = mbMap?.getStyle();
    const source = mbMap?.getSource(SEV_SOURCE_ID);

    let key;
    const onRetry = () => {
      setRetry(retry + 1);
    };

    if (!source) {
      if (mbMap && !style) {
        mbMap.once("idle", onRetry);
      } else if (!backgroundLayer.mbMap && !backgroundLayer.loaded) {
        key = backgroundLayer.once("load", onRetry);
      }
    } else {
      setSevSource(source);
    }

    return () => {
      mbMap?.off("idle", onRetry);
      unByKey(key);
      setSevSource();
    };
  }, [backgroundLayer, mode, retry]);

  useEffect(() => {
    if (!sevSource) {
      return;
    }
    const sevFeatures = [];

    // We create multiple background and dotted lines, so dotted lines are overlapped by each other [SBAHNMW-965].
    busTrajectories
      .filter((busFeatureCollection) => {
        return !!busFeatureCollection?.features?.[0]?.properties?.train_id;
      })
      .forEach((busFeatureCollection) => {
        const id = busFeatureCollection?.features?.[0]?.properties?.train_id;
        const source = {
          data: format.writeFeaturesObject(
            formatToLonLat.readFeatures(busFeatureCollection),
          ),
          type: "geojson",
        };

        // New display using the maplibre style
        sevFeatures.push(...source.data.features);
      });
    // Use the maplibre style to drawn sev lines.
    sevSource.setData({ features: sevFeatures, type: "FeatureCollection" });
  }, [busTrajectories, sevSource]);

  return null;
}

export default memo(SevLayer);
